import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD HH:mm',
  },
  display: {
    dateInput: 'YYYY-MM-DD HH:mm',
    monthYearLabel: 'YYYYY-MM-DD HH:mm',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY-MM-DD HH:mm',
  },
  useUtc: true,
};

const VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DateTimePickerComponent),
  multi: true,
};

@Component({
  selector: 'Teranet-DateTimePicker',
  templateUrl: 'date-time-picker.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },

    VALUE_ACCESSOR,
  ],
})
export class DateTimePickerComponent implements OnInit {
  @Input() classCss: string;
  @Input() disabled: boolean = false;
  @Input() error: string = '';
  @Input() hideTime: boolean = false;
  @Input() label: string;
  @Input() maxDate: Date;
  @Input() minDate: Date;
  @Input() required: boolean = false;
  @Output() inputChange = new EventEmitter<any>();
  @ViewChild('picker') picker: any;
  stepHour = 1;
  stepMinute = 1;
  stepSecond = 1;
  private dateTimeValue: any;

  ngOnInit() { }

  onChange = _ => { };

  onTouched = () => { };

  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }

  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  // write the value to the input
  writeValue(value: any) {
    this.dateTimeValue = value;
    this.onChange(value);
  }
  // get value for component from private variable
  get value(): any {
    return this.dateTimeValue;
  }
  // set the value (emit) to the parent model
  set value(value: any) {
    if (value !== this.dateTimeValue) {
      if (value) {
        if (!this.hideTime) {
          this.dateTimeValue = value.format('YYYY-MM-DDTHH:mm');
        }
        else {
          this.dateTimeValue = value.format('YYYY-MM-DD');
        }
      }
      this.onChange(value);
    }
    this.inputChange.emit(value);
  }
}
